import React, { PureComponent } from 'react'
import { number } from 'prop-types'
import { translate } from 'react-i18next'
import { Text, Icon } from 'components'
import { Panel } from './index'

const NUM_TOTAL_CIRCUITS = 6

@translate()
export class PanelCircuit extends PureComponent {
    static propTypes = {
        season: number.isRequired,
        race: number.isRequired,
        totalRaces: number.isRequired,
        laps: number.isRequired,
        lapLength: number.isRequired,
        temperature: number.isRequired,
        weather: number.isRequired,
        humidity: number.isRequired
    }
    static defaultProps = {
        laps: 0,
        lapLength: 0,
        temperature: 0,
        weather: 0,
        humidity: 0
    }

    render() {
        const { season, race, totalRaces, laps, lapLength, temperature, weather, humidity, className, t, tReady, ...otherProps } = this.props
        const numRace = (race - 1) % NUM_TOTAL_CIRCUITS
        const circuitImg = `/assets/circuits/circuit_${numRace + 1}.svg`
        const humidityLabel = t(`game.PRE_RACE.circuit.humidityLabel.${humidity}`)
        return (
            <Panel className={['PanelCircuit', className]} {...otherProps}>
                <div className="flex row-stretch">
                    <div>
                        <Text className="PanelCircuit-Title">{t('game.PRE_RACE.circuit.characteristics')}</Text>
                        <div className="PanelCircuit-Stat">
                            <Text className="PanelCircuit-Label">{t('game.PRE_RACE.circuit.laps')}</Text>
                            <Text className="PanelCircuit-Value">{laps}</Text>
                        </div>
                        <div className="PanelCircuit-Stat">
                            <Text className="PanelCircuit-Label">{t('game.PRE_RACE.circuit.lapLength')}</Text>
                            <Text className="PanelCircuit-Value">{lapLength}</Text>
                        </div>
                    </div>

                    <div className="PanelCircuit-Map">
                        <img src={circuitImg} />
                    </div>

                    <div>
                        <div className="PanelCircuit-Stat">
                            <Text className="PanelCircuit-Label">{t('game.PRE_RACE.circuit.weather')}</Text>
                            <div className="PanelCircuit-Weather">
                                <Icon name="sunny" className={{ Active: weather === 1 }} />
                                <Icon name="partially-cloudy" className={{ Active: weather === 2 }} />
                                <Icon name="cloudy" className={{ Active: weather === 3 }} />
                            </div>
                        </div>
                        <div className="PanelCircuit-Stat">
                            <Text className="PanelCircuit-Label">{humidityLabel}</Text>
                            <div className="PanelCircuit-Humidity">
                                <Icon name="drop" className={{ Active: humidity >= 1 }} />
                                <Icon name="drop" className={{ Active: humidity >= 2 }} />
                                <Icon name="drop" className={{ Active: humidity >= 3 }} />
                                <Icon name="drop" className={{ Active: humidity >= 4 }} />
                            </div>
                        </div>
                        <div className="PanelCircuit-Stat">
                            <Text className="PanelCircuit-Label">{t('game.PRE_RACE.circuit.temperature')}</Text>
                            <Text className="PanelCircuit-Temperature">{temperature}º</Text>
                        </div>
                    </div>
                </div>
            </Panel>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Panel/PanelCircuit.js